import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import Preloader from "../helper/Preloader";

import Header from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import BottomFooter from "../components/BottomFooter";
import OrderTracking from "../components/orders/OrderTracking";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { trackOrderDetail } from "../redux/actions/action-creator";


const OrderTrackingPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { user_location } = useSelector((state) => state.auth);
  const [trackingData, setTrackingData] = useState(null);
  const [trackingLoading, setTrackingLoading] = useState(true);
  const [trackingError, setTrackingError] = useState("");

  const savedMerchantId = useMemo(() => {
    try {
      const savedLocation = localStorage.getItem("user_location");
      const parsedLocation = savedLocation ? JSON.parse(savedLocation) : null;
      return parsedLocation?.merchant_id || parsedLocation?.merchantId || 1;
    } catch (error) {
      return 1;
    }
  }, []);

  const orderId = location.state?.order_id || searchParams.get("order_id");
  const merchantId =
    location.state?.merchant_id ||
    searchParams.get("merchant_id") ||
    user_location?.merchant_id ||
    user_location?.merchantId ||
    savedMerchantId ||
    1;

  useEffect(() => {
    let isMounted = true;

    const loadTrackingDetail = async () => {
      if (!orderId) {
        setTrackingData(null);
        setTrackingError("Order id not found.");
        setTrackingLoading(false);
        return;
      }

      setTrackingLoading(true);
      setTrackingError("");

      const formData = new FormData();
      formData.append("order_id", orderId);
      formData.append("merchant_id", merchantId);

      try {
        const response = await dispatch(trackOrderDetail(formData));
        if (isMounted) {
          setTrackingData(response?.data || response || null);
        }
      } catch (error) {
        if (isMounted) {
          setTrackingData(null);
          setTrackingError(
            error?.response?.data?.message ||
            error?.message ||
            "Unable to fetch order tracking detail."
          );
        }
      } finally {
        if (isMounted) {
          setTrackingLoading(false);
        }
      }
    };

    loadTrackingDetail();

    return () => {
      isMounted = false;
    };
  }, [dispatch, orderId, merchantId]);

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* Header */}
      <Header category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Order tracking"} />

      {/* Account */}
      <OrderTracking
        trackingData={trackingData}
        loading={trackingLoading}
        error={trackingError}
        orderId={orderId}
      />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default OrderTrackingPage;
